import React, { Suspense, useEffect } from 'react';
import { useReadAloudStore } from '@/store/readAloud';
import { useAuthStore } from '@/store/auth';

const Session = React.lazy(() => import('./ReadAloudSession'));

export default function ReadAloudHost({ allowed = true }) {
  const session = useReadAloudStore(state => state.session);
  useEffect(() => useAuthStore.subscribe((next, previous) => {
    if ((!next.token && previous.token) || next._isSigningOut ||
        next._sessionGeneration !== previous._sessionGeneration) {
      useReadAloudStore.getState().stop();
    }
  }), []);
  useEffect(() => { if (!allowed) useReadAloudStore.getState().stop(); }, [allowed]);
  return allowed && session ? <Suspense fallback={null}><Session key={session.id} text={session.text} /></Suspense> : null;
}
